export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      spAppLaunchInfo: {
        yearMonth: "2021年03月",
        dailyLaunchInfo: [
          {
            activedate: "2021年03月01日",
            activeCount: 15
          }
        ]
      }
    }
  }
}